<div>

    @if (isTitleShown) {
        <div class="row alert wp-label-text left-text">
            <h4 class="wp-header-text">{{title}}</h4>
        </div>
    }

    <br/>

    @if (isSubtitleShown) {
        <div class="row alert wp-label-text">
            <h5 class="wp-header-text">{{subtitle}}</h5>
        </div>
    }

    <!-- <br/> -->

    <div class="row alert ">

        @if(isEmailShown) {

            <!-- <form [formGroup]="emailForm" (change)="formChanged()"> -->
            <form (ngSubmit)="onSendEmail()" [formGroup]="emailForm">

                <div class="form-group row align-items-center">
                    <label for="emailAddress" class="col-sm-2 col-form-label wp-label-text">{{emailLabel}}</label>
                    <div class="col-sm-3">
                        <input type="email" formControlName="emailAddress" class="form-control" id="emailAddress" value="" placeholder="{{emailPrompt}}">
                    </div>
    
                    <div class="col-sm-2">
                        <button type="submit" icon="fa fa-check" class="wp-btn wp-btn-submit" [disabled]="!emailForm.valid">{{emailButton}}</button>
                    </div>
                </div>
                <!-- @if (!emailForm.controls['emailAddress'].valid && emailForm.controls['emailAddress'].dirty) {
                    <div class="col-sm-3 alert alert-danger">
                        Incorrect email address
                    </div>
                } -->
                @if (!emailForm.get('emailAddress')?.valid && emailForm.get('emailAddress')?.dirty) {
                    <div class="col-sm-3 alert alert-danger">
                        Incorrect email address
                    </div>
                }

            </form>

        }

        @if(isSMSShown) {

            <form [formGroup]="phoneForm" (change)="formChanged()">

                <div class="form-group row align-items-center">
                    <label for="phoneNumber" class="col-sm-2 col-form-label wp-label-text">{{smsLabel}}</label>
                    <div class="col-sm-2">
                        <input type="text" class="form-control" formControlName="phoneNumber" id="phoneNumber" value="" placeholder="{{smsPrompt}}">
                    </div>
    
                    <div class="col-sm-2">
                        <button type="submit" icon="fa fa-check" class="wp-btn wp-btn-submit" (click)="onSendSMS()" [disabled]="!phoneForm.valid">{{smsButton}}</button>
                    </div>
    
                </div>
                @if (!phoneForm.get('phoneNumber')?.valid && phoneForm.get('phoneNumber')?.dirty) {
                    <div class="col-sm-3 alert alert-danger">
                        Incorrect phone number
                    </div>
                }
            </form>
        }
    </div>

    <div class="row alert ">
        <div class="col-sm-4">
            @if (isSuccessMessageShown) {
                <div class="alert alert-success" role="alert">{{successMessage}}</div>
            }
            @if (isErrorMessageShown) {
                <div class="alert alert-danger" role="alert">{{errorMessage}}</div>
            }    
        </div>
    </div>    


    <!-- <br/> -->

    @if (isSMSDisclaimerShown) {
        <div class="row alert">
            <div class="col-sm-6">
                <h5 class="wp-header-text">{{smsDisclaimer}}</h5>
            </div>
        </div>
    }

    <br/>


    @if (isQrCodeUrlShown) {
        <div class="row alert ">

            <div class="form-group row">
                <label class="col-sm-2 col-form-label wp-label-text">{{qrInvitationText}}</label>
                <div class="col-sm-5">
                    <div class="wp-image-text-image" style="text-align: left;">
                        <img id="qrCode" src="{{qrCodeUrl}}" alt="" width="200" height="200" />
                    </div>
                </div>
            </div>

        </div>
    }


</div>
